/* @flow */
import styled from 'styled-components'
import { styleProvider } from '@website/common/utils'
import THEME from '../CTA13.theme'

const getStyleForProp = styleProvider(THEME)

export const MorphBottomWrapper = styled.div`
  width: 58%;
  position: absolute;
  z-index: 4;
  bottom: -24%;
  right: -20%;
  @media only screen and (max-width: 450px) {
    bottom: -46%;
  }
  svg {
    width: 100%;
  }
  .a {
    fill: ${getStyleForProp('imageSecondaryColor')};
  }
  .b {
    fill: ${getStyleForProp('imagePrimaryColor')};
  }
  .c {
    fill: ${getStyleForProp('imageTertiaryColor')};
  }
`
